export const de = {
  App: {
    navigationConfigurations: {
      pageTitle: {
        administrationTimeTrackingActivities: 'Admin - Tätigkeiten',
        administrationTimeTrackingActivityCompilations: 'Admin - Sammlungen',
        administrationTimeTrackingConfigurations:
          'Admin - Zeitaufnahmekonfigurationen',
        administrationUsergroups: 'Admin - Benutzergruppen',
        administrationUsers: 'Admin - Benutzer',
        constructionSiteOverview: 'Baustellen verwalten',
        createConstructionSite: 'Baustelle erstellen',
        createWorkTimeEntry: 'Arbeitszeit erfassen',
        createWorkTimeEntryCreateConstructionSite: 'Baustelle erstellen',
        createWorkTimeEntrySelectActivity: 'Tätigkeit auswählen',
        createWorkTimeEntrySelectConstructionSite: 'Baustelle auswählen',
        forgotPassword: 'Passwort vergessen',
        home: 'Home',
        login: 'Login',
        resetPassword: 'Passwort zurücksetzen',
        trackedWorkTimeAdmin: 'Arbeitszeiten verwalten',
        trackedWorkTimeEdit: 'Arbeitszeit bearbeiten',
        trackedWorkTimeOverview: 'Meine Arbeitszeit'
      }
    }
  },
  components: {
    authentication: {
      AutoReauthenticateDialog: {
        title: 'Passwort eingeben'
      }
    },
    constructionSite: {
      ConstructionSiteToSelectListItem: {
        distance: 'Entfernung'
      },
      CreateConstructionSiteForm: {
        cancel: 'Abbrechen',
        create: 'Erstellen'
      },
      CreateConstructionSitePageContent: {
        noCompilationFound:
          'Die Baustelle kann nicht erstellt werden, da keine Tätigkeitssammlung existiert. Bitte erstellen Sie eine Tätigkeitssammlung und versuchen Sie es dann erneut.',
        title: 'Baustelle erstellen'
      },
      EditConstructionSiteDialog: {
        title: 'Baustelle bearbeiten'
      },
      NearbyConstructionSitesToSelectList: {
        noNearbyConstructionSites:
          'Es wurden keine Baustellen in der Nähe gefunden.'
      }
    },
    input: {
      ConstructionSiteSelect: {
        constructionSiteNotFound: 'Unbekannte Baustelle',
        label: 'Baustelle',
        noConstructionSite: 'Keine Baustelle'
      },
      UserGroupSelect: {
        label: 'Benutzergruppe',
        noUserGroup: 'Keine Benutzergruppe',
        userGroupNotFound: 'Unbekannte Benutzergruppe'
      },
      UserSelect: {
        label: 'Benutzer',
        noUser: 'Kein Benutzer',
        userNotFound: 'Unbekannter Benutzer'
      },
      MonthSelect: {
        label: 'Monat'
      }
    },
    layout: {
      DefaultLayout: {
        navigationItems: {
          adminWorkTime: 'Arbeitszeiten verwalten',
          constructionSite: 'Baustellen',
          home: 'Home',
          myWorkTimeOverviewPage: 'Meine Arbeitszeit',
          timeTrackingActivityCompilation: 'Tätigkeitensammlungen',
          timeTrackingConfiguration: 'Zeitaufnahmekonfigurationen',
          userGroups: 'Benutzergruppen',
          users: 'Benutzer'
        }
      }
    },
    page: {
      ConstructionSiteAdminPage: {
        create: 'Baustelle erstellen',
        title: 'Baustellen'
      },
      CreateWorkTimeEntryPage: {
        create: 'Erfassen',
        createdNotification: {
          title: 'Arbeitszeit erfasst!',
          message: 'Die Arbeitszeit wurde erfolgreich erfasst'
        },
        endDate: 'Ende',
        note: 'Anmerkung',
        startDate: 'Start',
        title: 'Arbeitszeit erfassen',
        workTime: 'Gesamte Arbeitszeit: '
      },
      CreateWorkTimeEntrySelectActivityPage: {
        title: 'Tätigkeit auswählen'
      },
      CreateWorkTimeEntrySelectConstructionSitePage: {
        createConstructionSite: 'Baustelle erstellen',
        groupHeaders: {
          all: 'Alle',
          mostUsed: 'Meist verwendet',
          nearby: 'In der Nähe'
        },
        searchInputPlaceholder: 'Baustelle suchen',
        title: 'Baustelle auswählen'
      },
      EditWorkTimeEntryPage: {
        entryNotFound: 'Eintrag wurde nicht gefunden',
        title: 'Arbeitszeit bearbeiten'
      },
      HomePage: {
        createWorkTimeEntry: 'Arbeitszeit ohne Stoppuhr erfassen',
        noUserGroupsAvailable:
          'Sie sind keiner Benutzergruppe zugeordnet. Bitte lassen Sie sich zu einer Benutzergruppe hinzufügen.',
        title: 'Home'
      },
      LoginPage: {
        loginFailed: 'Login fehlgeschlagen'
      },
      MyWorkTimeOverviewPage: {
        pageTitle: 'Meine Arbeitszeit'
      },
      TimeTrackingActivityAdminPage: {
        createEntity: 'Tätigkeit erstellen',
        pageTitle: 'Tätigkeiten'
      },
      TimeTrackingActivityCompilationAdminPage: {
        createEntity: 'Sammlung erstellen',
        pageTitle: 'Tätigkeitensammlung'
      },
      TimeTrackingConfigurationAdminPage: {
        createEntity: 'Konfiguration erstellen',
        pageTitle: 'Zeitaufnahmekonfigurationen'
      },
      UserAdminPage: {
        createEntity: 'Benutzer erstellen',
        pageTitle: 'Benutzer'
      },
      UserGroupAdminPage: {
        createEntity: 'Benutzergruppe erstellen',
        pageTitle: 'Benutzergruppen'
      },
      WorkTimeAdminPage: {
        pageTitle: 'Arbeitszeitenverwaltung'
      }
    },
    timeTracking: {
      CreateTimeEntryBreakInline: {
        cancel: 'Abbrechen',
        create: 'Erstellen',
        label: 'Neue Pause',
        startCreatingBreak: 'Pause hinzufügen'
      },
      EditWorkTimeEntryBreaksWidget: {
        title: 'Pausen'
      },
      StartNewStopwatchFixedButton: {
        startNewStopwatch: 'Neue Stoppuhr',
        userGroupSelectionTitle: 'Benutzergruppenauswahl'
      },
      TrackedWorkTimeLine: {
        legend: {
          break: 'Pause',
          workTime: 'Arbeitszeit'
        }
      }
    },
    timeTrackingActivity: {
      EditTimeTrackingActivityDialog: {
        title: 'Tätigkeit bearbeiten'
      }
    },
    timeTrackingActivityCompilation: {
      EditTimeTrackingActivityCompilationDialog: {
        tabTitle: 'Tätigkeitensammlung bearbeiten'
      },
      TimeTrackingActivityCompilationSelect: {
        label: 'Tätigkeitssammlung',
        unknownItem: 'Unbekannte Sammlung'
      }
    },
    timeTrackingConfiguration: {
      EditTimeTrackingConfigurationDialog: {
        title: 'Zeitaufnahmekonfiguration bearbeiten'
      },
      TimeTrackingConfigurationSelect: {
        label: 'Zeitaufnahmekonfiguration',
        notFound: 'Unbekannte Konfiguration',
        nullValue: 'Keine Konfiguration'
      }
    },
    user: {
      CreateUserDialog: {
        cancel: 'Abbrechen',
        create: 'Erstellen',
        failedToCreateUser: 'Erstellen des Benutzers fehlgeschlagen',
        noEmailProvided: 'Es wurde keine E-Mail angegeben',
        noPasswordProvided: 'Es wurde kein Passwort angegeben',
        title: 'Benutzer erstellen'
      },
      EditUserDialog: {
        admin: 'Administrator',
        title: 'Benutzer bearbeiten'
      },
      UserProfileDialog: {
        title: 'Profil'
      }
    },
    userGroup: {
      EditUserGroupDialog: {
        title: 'Benutzergruppe bearbeiten'
      },
      UserGroupToUsersWidget: {
        UserGroupToUsersWidgetUser: {
          unknownUser: 'Unbekannter Benutzer'
        }
      }
    },
    workTime: {
      ExportAdminWorkTimeDialog: {
        exports: {
          activities: {
            title: 'Tätigkeitenübersicht',
            fileName: 'Tätigkeitenübersicht {{year}}.xlsx'
          },
          allTimesheetsForUserGroup: {
            title: 'Alle Stundenzettel',
            fileName: 'Stundenzettel {{month}}.{{year}}.zip'
          },
          constructionSite: {
            title: 'Baustellenübersicht',
            fileName: 'Baustellenübersicht {{year}}.xlsx'
          },
          constructionSiteSummary: {
            title: 'Baustelle',
            fileName: 'Baustelle - {{name}}.xlsx'
          },
          fullExport: {
            title: 'Alle Zeiten',
            fileName: 'Gesamtexport {{year}}.xlsx'
          }
        }
      },
      ExportWorkTimeBaseDialog: {
        cancel: 'Abbrechen',
        export: 'Exportieren',
        exportError: 'Export Fehlgeschlagen',
        exports: {
          csv: {
            title: '.csv Export',
            fileName: {
              withMonth: 'Stundenblatt {{userName}}.{{month}}.{{year}}.csv',
              withoutMonth: 'Stundenblatt {{userName}}.{{year}}.csv'
            }
          },
          timesheet: {
            title: 'Stundenzettel',
            fileName: 'Stundenzettel {{user}}.{{month}}.{{year}}.xlsx'
          }
        },
        title: 'Arbeitszeiten exportieren'
      },
      ExportYearSelect: {
        label: 'Jahr'
      },
      TodaysWorkTimeInfo: {
        moreInfosTitle: 'Arbeitszeiten anzeigen ({{ count }})',
        moreInfosTitle_expanded: 'Arbeitszeiten ausblenden ({{ count }})',
        workTime: 'Heute erfasste Arbeitszeit: '
      },
      TodaysWorkTimeInfoDetailEntry: {
        break: 'Pause'
      },
      WorkTimeEntryActivityWidget: {
        label: 'Tätigkeit',
        noActivity: 'Keine Tätigkeit'
      },
      WorkTimeEntryListItem: {
        noActivity: 'Keine Tätigkeit'
      },
      WorkTimeEntryNoteWidget: {
        label: 'Anmerkung',
        noNote: 'Keine Anmerkung'
      },
      WorkTimeEntryToCreateActivityWidget: {
        selectActivity: 'Tätigkeit auswählen',
        selectActivity_activityAlreadySelected: 'Andere Tätigkeit auswählen',
        title: 'Tätigkeit'
      },
      WorkTimeEntryToCreateConstructionSiteWidget: {
        unknownConstructionSite: 'Unbekannte Baustelle',
        selectConstructionSite: 'Baustelle auswählen',
        selectConstructionSite_constructionSiteAlreadySelected:
          'Andere Baustelle auswählen',
        title: 'Baustelle'
      }
    }
  },
  date: {
    monthLong: {
      allMonths: 'Alle Monate',
      january: 'Jänner',
      february: 'Februar',
      march: 'März',
      april: 'April',
      may: 'Mai',
      juni: 'Juni',
      july: 'Juli',
      august: 'August',
      september: 'September',
      october: 'Oktober',
      november: 'November',
      december: 'Dezember'
    }
  },
  entities: {
    ConstructionSite: {
      archived: 'Archiviert',
      compilationId: 'Tätigkeitssammlung',
      location: 'Koordinaten',
      name: 'Name'
    },
    TimeTrackingActivity: {
      name: 'Name'
    },
    TimeTrackingActivityCompilation: {
      name: 'Name'
    },
    TimeTrackingConfiguration: {
      maxWorkHoursPerDay: 'Maximale tägliche Arbeitszeit (Stunden)',
      name: 'Name'
    },
    User: {
      email: 'E-Mail',
      name: 'Name',
      password: 'Passwort'
    },
    UserGroup: {
      name: 'Name',
      users: {
        groupAdmin: 'Admin'
      }
    },
    WorkTimeEntry: {
      WorkTimeEntryBreak: {
        endDate: 'Ende',
        startDate: 'Start'
      }
    }
  },
  filters: {
    archivedFilter: {
      all: 'Alle anzeigen',
      label: 'Archiviert',
      notArchived: 'Nicht archiviert',
      onlyArchived: 'Archiviert'
    },
    constructionSiteTextFilter: {
      label: 'Textsuche'
    },
    userIdUrlFilter: {
      label: 'Benutzer',
      unknownUser: 'Unbekannter Benutzer'
    }
  },
  hooks: {
    entity: {
      timeTrackingActivity: {
        unknownActivity: 'Unbekannte Aktivität'
      }
    },
    validation: {
      functions: {
        validateBreak: {
          breakMustNotOverlapWithExistingBreak:
            'Pause darf nicht mit anderer überlappen',
          breakMustOccurInWorkTime:
            'Pause muss innerhalb der Arbeitszeit erfolgen',
          endBeforeStartDate: 'Enddatum muss nach dem Startdatum sein'
        },
        validateWorkTimeEntryDates: {
          endBeforeStartDate: 'Enddatum muss nach dem Startdatum sein'
        }
      }
    }
  }
};
